var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.8 5.40039C7.8 7.05039 6.45 8.40039 4.8 8.40039C3.15 8.40039 1.8 7.05039 1.8 5.40039C1.8 3.75039 3.15 2.40039 4.8 2.40039C6.45 2.40039 7.8 3.75039 7.8 5.40039ZM22.2 5.40039C22.2 7.05039 20.85 8.40039 19.2 8.40039C17.55 8.40039 16.2 7.05039 16.2 5.40039C16.2 3.75039 17.55 2.40039 19.2 2.40039C20.85 2.40039 22.2 3.75039 22.2 5.40039ZM20.7 9.60039H18.375C17.8875 9.60039 17.4375 9.71289 17.025 9.90039L17.0413 9.99659C17.0726 10.1801 17.1 10.3402 17.1 10.5004C17.1 11.7754 16.6125 12.9004 15.8625 13.8004H23.325C23.7 13.8004 24 13.5004 24 13.0879C24 11.1754 22.5375 9.60039 20.7 9.60039ZM5.625 9.60039C6.1125 9.60039 6.5625 9.71289 6.975 9.90039C6.9375 10.0879 6.9 10.3129 6.9 10.5004C6.9 11.7754 7.3875 12.9004 8.1375 13.8004H0.675C0.3 13.8004 0 13.5004 0 13.0879C0 11.1754 1.4625 9.60039 3.3 9.60039H5.625Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8998 10.5006C15.8998 12.6381 14.1373 14.4006 11.9998 14.4006C9.8248 14.4006 8.0998 12.6381 8.0998 10.5006C8.0998 8.36309 9.8248 6.60059 11.9998 6.60059C14.1373 6.60059 15.8998 8.36309 15.8998 10.5006ZM4.7998 20.5881C4.7998 17.8506 7.1998 15.6006 10.1248 15.6006H13.8748C16.7998 15.6006 19.1998 17.8506 19.1998 20.5881C19.1998 21.1506 18.7123 21.6006 18.1498 21.6006H5.8498C5.2873 21.6006 4.7998 21.1506 4.7998 20.5881Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.09315c8b3175a795968204a4e49e6ca0.svg";
export { ForwardRef as ReactComponent };